export type ClinicAddressFields = {
  endereco?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  estado?: string;
  cep?: string;
};

const clean = (value?: string) => value?.trim() || "";

export function clinicValue(clinicValue?: string, detailValue?: string) {
  return clean(clinicValue) || clean(detailValue);
}

export function clinicAddress(
  clinic: ClinicAddressFields | null,
  detail: ClinicAddressFields | null
): Required<ClinicAddressFields> {
  const source = clean(clinic?.endereco) ? clinic : detail;

  return {
    endereco: clean(source?.endereco),
    numero: clean(source?.numero),
    complemento: clean(source?.complemento),
    bairro: clean(source?.bairro),
    cidade: clean(source?.cidade),
    estado: clean(source?.estado).toUpperCase(),
    cep: clean(source?.cep),
  };
}

export function formatClinicAddress(clinic: ClinicAddressFields | null | undefined) {
  return [
    clinic?.endereco,
    clinic?.numero,
    clinic?.complemento,
    clinic?.bairro,
    clinic?.cidade,
    clinic?.estado,
    clinic?.cep,
  ].map(clean).filter(Boolean).join(" - ");
}
